<script>
// import RexModal from '@/rex-components/rex-modal.vue';
import RexModalV3 from '@/rex-components/RexModalV3.vue';
// import RexButton from '@/rex-components/rex-button.vue';
// import Loading from '@/rex-components/rex-loading.vue';
import { mapMutations, mapActions, mapGetters, mapState } from 'vuex';
import { usePermissions } from '@/hooks/usePermissions';
import {
  LOG_RESOURCE_GROUP,
  ANALYTICS_RESOURCE_GROUP,
} from '@/router/constant';
import Loading from '@/rex-components/rex-loading.vue';

export default {
  components: { RexModalV3, Loading },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    saveSearchName: {
      type: String,
      default: '',
    },
    serviceId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      rulesLoading: false,
    };
  },
  computed: {
    ...mapGetters('alertV2State/configure', ['getTotalRules']),
    ...mapState('logState/logCommonState', ['isADType']),
    disableAlertDeletion() {
      const { hasCapabilityAlertWritePermission } = usePermissions();
      return (
        this.getTotalRules > 0 &&
        !hasCapabilityAlertWritePermission(
          this.isADType ? ANALYTICS_RESOURCE_GROUP : LOG_RESOURCE_GROUP,
        )
      );
    },
  },
  methods: {
    ...mapMutations('globalState/app', ['setIsFormOpened']),
    ...mapActions('alertV2State/configure', ['getAlertRules']),
    async getConfigured() {
      try {
        this.rulesLoading = true;
        let param = {
          keyword: '',
          serviceId: this.serviceId,
          limit: 10,
          from: 0,
          order: 'DESC',
          sortBy: 'lastUpdatedAt',
        };
        await this.getAlertRules(param);
      } catch (error) {
        console.log('error', error);
      } finally {
        this.rulesLoading = false;
      }
    },
  },
  async mounted() {
    await this.getConfigured();
  },
  unmounted() {
    this.setIsFormOpened(false);
  },
};
</script>

<template>
  <div>
    <RexModalV3
      :show="true"
      :title="$t('log.deleteSavedSearch')"
      :submitText="$t('log.delete')"
      @onClose="() => $emit('onClose')"
      @onSubmit="() => $emit('onSubmit')"
      :loading="isLoading"
      width="50rem"
      :submitBtnProps="disableAlertDeletion ? { disabled: true } : {}"
    >
      <template #body>
        <div v-if="rulesLoading">
          <Loading />
        </div>
        <div v-else>
          {{
            disableAlertDeletion
              ? $t('log.deleteSavedSearchWithAlertWarning', [saveSearchName])
              : $t('log.savedSearchWillBeDeleted', [saveSearchName])
          }}
        </div>
      </template>

      <!-- <template v-slot:footer>
        <div class="delete-saved-search-footer">
          <div>
            <RexButton
              variant="secondary"
              @onClick="$emit('onClose')"
              id="delete-saved-search-btn-cancel"
            >
              {{ $t('log.cancel') }}
            </RexButton>
          </div>
          <div class="saved-search-delete-btn">
            <RexButton
              :variant="isLoading ? 'disabled' : 'primary'"
              @onClick="$emit('onSubmit')"
              id="delete-saved-search-btn-submit"
              style="width: 6rem"
            >
              <Loading v-if="isLoading" :smallar="true" />
              <span v-else>
                {{ $t('log.delete') }}
              </span>
            </RexButton>
          </div>
        </div>
      </template> -->
    </RexModalV3>
  </div>
</template>

<style lang="scss" scoped>
.delete-saved-search-footer {
  @include flex-center-justify(flex-end);
}
.saved-search-delete-btn {
  margin-left: 1rem;
}
</style>
